// extracted by mini-css-extract-plugin
export default {"warning":"UnconfiguredModelCostWarning_warning__A27AD","icon":"UnconfiguredModelCostWarning_icon__MWUdt"};